<template>
  <v-text-field ref="input" :value="internalValue" @blur="updateInternalValue" :key="keyIterator" :disabled="disabled" :readonly="readonly" :loading='this.currentLoading'
                type="number" :max="maxValue" :min="minValue" outlined dense height="30" hideDetails="true" :prefix="prefix" :suffix="suffix" :class="classes"></v-text-field>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DataFormatter from '@/mixins/DataFormatter';
  import _debounce from 'lodash/debounce';


  const updateValue = function (newValue) {
    var t = this;
    t.touched = false;
    let n = t.halfRoundUp(newValue, t.precision);
    if (n == null || n == undefined || n == '' || isNaN(n)) {
      n == 0;
    }
    if ((t.maxValue == undefined || n <= t.maxValue) && (t.minValue == undefined || n >= t.minValue)) {

      t.$emit('input', n.toFixed(t.precision));
      t.$emit('update:value', n.toFixed(t.precision));
      t.keyIterator++;
    } else {
      let clampedValue = (t.maxValue != undefined && n > t.maxValue) ? Math.min(n, t.maxValue) : (t.minValue != undefined && n < t.minValue) ? Math.max(n, t.minValue) : n;
      t.$emit('input', clampedValue.toFixed(t.precision));
      t.$emit('update:value', clampedValue.toFixed(t.precision));
      t.keyIterator++;
    }
  };

  export default {
    name: 'ResNumberInputField',
    mixins: [
      DataFormatter
    ],
    data: function () {
      return {
        keyIterator: 0,
        internalValue: this.value,
        touched: false,
        debounceWait: 500,
        maxWait: 1000
      }
    },
    props: {
      value: {
        required: true
      },
      maxValue: {
        type: Number
      },
      minValue: {
        type: Number
      },
      classString: {
        type: String
      },
      readonly: {},
      disabled: {},
      suffix: {},
      prefix: {},
      precision: {
        type: Number,
        default: 0
      }
    },
    methods: {
      updateInternalValue(ev) {
        this.touched = true;
        this.updateValue(ev.target.value);
      },      
    },
    computed: {
      ...mapGetters(['currentLoading']),
      classes() {
        return 'res-number-input ' + this.classString;
      },
      updateValue() {
        return _debounce(updateValue, this.debounceWait, { 'maxWait': this.maxWait });
      }
    },
    watch: {
      value(value) {
        if (!this.touched) this.internalValue = value;
      },
    }
  }
</script>

<style scoped lang="scss">
  .res-number-input {
    .v-text-field--outlined.v-input--is-focused::v-deep fieldset {
      border-color: var(--v-resBlue-darken1) !important;
    }
    .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)::v-deep fieldset {
      border-color: var(--v-resGrey-darken1) !important;
    }
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
</style>
